<template>
  <app-base-main headFixed v-loading="pageLoading" :baseStyle="{ background: 'none'}">
    <template #base-content>
      <app-left-right>
        <template #left>
          <div class="right-market">{{ publicObj.SB.market.name }}:{{ publicObj.SB.market.countryCode }}</div>
          <div class="left-content">
            <div class="left-cell" v-for="(item, index) in leftSign" :key="item.index" @click="anchorRoll(`#id${item.index}`)" :class="{'active': item.index == forms.leftIndex, 'guide-line': item.index < forms.leftIndex}">
              <div class="cell-index" v-if="item.index == forms.leftIndex || !item.complete">{{ index + 1 }}</div>
              <div class="cell-index cell-complete" v-else><i class="el-icon-check"></i></div>
              <div class="cell-title">{{ item.title }}</div>
            </div>
          </div>
        </template>
        <template #right>
          <div class="right-content">
            <div class="right-scroll" ref="rightContent" @scroll="rightContentScroll">
              <add-cell class="AddBase" cellTitle="基础信息" id="id1">
                <AddBase />
              </add-cell>
              <add-cell class="AddAdvertisingFormat" cellTitle="广告格式" id="id2">
                <AddAdvertisingFormat />
              </add-cell>
              <add-cell class="AddOriginality" cellTitle="创意" id="id3">
                <AddOriginality />
              </add-cell>
              <add-cell class="AddLaunchType" v-if="true" cellTitle="投放类型" id="id4">
                <AddLaunchType ref="AddLaunchType" />
              </add-cell>
            </div>
            <div class="right-footer">
              <gj-button :disabled="formsError.status == 1" @click="saveDraft">暂存草稿</gj-button>
              <gj-button type="primary" class="ml18" @click="confirm">提交审核</gj-button>
            </div>
          </div>
        </template>
      </app-left-right>
    </template>
  </app-base-main>
</template>

<script>
import AddCell from './components/add-cell'
import AddPopup from './components/other/popup'
import AddBase from './components/add-base/add-base'
import AddAdvertisingFormat from './components/add-advertising-format/add-advertising-format'
import AddLaunchType from './components/add-launch-type/add-launch-type'
import AddOriginality from './components/add-originality/add-originality'
import { convertToDate } from '@/utils/date.util'
import { getMarket } from "@/api/common";
import { listProductBrand , getLandingPage, saveAdsSbCampaigns, getLogCacheByBrandEntityId, Portfolios, campaignInfo } from "@/api/ad";
import {AdDefaultBid} from "@/views/modules/ad/common/enum";
import {mapGetters} from "vuex";

export default {
  name: "app-sb-add",
  components: {AddCell, AddBase, AddAdvertisingFormat, AddLaunchType, AddOriginality},
  inject: ['removeTab', 'removeTabList'],
  async created() {
    this.publicObj.SB.marketId = this.$route.query.marketId;
    this.publicObj.SB.defaultBid = AdDefaultBid[this.markets.find(r => r.id === this.$route.query.marketId).countryCode]?.SBDefaultBid || null;
    this.pageLoading = true;
    await this.getMarket(this.publicObj.SB.marketId);
    await this.getPortfolio(this.publicObj.SB.marketId);
    await this.listProductBrand(this.publicObj.SB.marketId);
    if (this.$route.query.oldMarketId) {
      await this.campaignInfo({marketId: this.$route.query.oldMarketId})
      this.forms.addBase.brandEntityId && await this.getLandingPage()
    }
    this.pageLoading = false
  },
  async activated() {
    this.pageLoading = true
    if (this.publicObj.SB.marketId != this.$route.query.marketId) { // 判断路由的站点id和缓存的页面的站点id是否一致
      this.publicObj.SB.marketId = this.$route.query.marketId
      this.publicObj.SB.defaultBid = AdDefaultBid[this.markets.find(r => r.id === this.$route.query.marketId).countryCode]?.SBDefaultBid || null;
      await this.getMarket(this.publicObj.SB.marketId);
      await this.getPortfolio(this.publicObj.SB.marketId);
      await this.listProductBrand(this.publicObj.SB.marketId);
    }
    this.publicObj.SB.marketId = this.$route.query.marketId
    if (this.$route.query.oldMarketId) {
      await this.campaignInfo({marketId: this.$route.query.oldMarketId})
      this.forms.addBase.brandEntityId && await this.getLandingPage()
    }
    this.$nextTick(() => {
      this.$refs.rightContent.scrollTop = this.rightScrollTop
      this.pageLoading = false
    })
  },
  data() {
    return {
      convertToDate,
      pageLoading: false,
      rightScrollTop: 0,
      leftSign: [
        { title: "基础信息", index: "1", height: '500px', complete: false},
        { title: "广告格式", index: "2", height: '500px', complete: false},
        { title: "创意", index: "3", height: '500px', complete: false},
        { title: "投放类型", index: "4", height: '500px', complete: false},
      ],
      publicObj: {
        SB: {
          isAdsAuth: false, // 站点是否授权广告
          isBrand: -1, // 站点是否有品牌 0：正在校验 1：无品牌 2：有品牌
          marketId: null,
          market: {},
          currencySymbol: null,
          rootMountEl: null,
          portfolios: [],
          campaign: null,
          group: null,
          campaignDate: null,
          groupDate: null,
          defaultBid: null// 默认竞价
        }
      },
      options: {
        loading: {
          brandEntity: false,
          shopOptions: false,
        },
        brandEntity: [], // 品牌
        shopOptions: [], // 店铺着陆页
      },
      forms: {
        leftIndex: "1", // [前端自用展示]
        draft: 0, // 草稿标志（0：草稿；1：非草稿）
        marketId: null, // 站点id
        addBase: { // 1. 基础信息
          name: null, // 广告活动名称
          budget: null, // 活动预算
          budgetType: 1, // 0:lifetime：生命周期,1: daily：每日
          startDate: new Date(), // 活动开始时间（YYYY-MM-DD）
          endDate: null, // 活动结束时间（YYYY-MM-DD）
          brandEntityId: null, // 品牌id
          portfolioId: null, // 广告组合id
        },
        addAdvertisingFormat: { // 2. 广告格式
          adFormat: 0, // 0：productCollection ： 品牌广告商品集合广告,1：video ： 品牌广告视频广告	
          adFormatUrl: null, // 0: url 1: 商品
          landingPage: {
            asins: [],
            asinsItem: [],
            url: null
          },
        },
        creative: { // 3. 创意
          imgInfo: {}, //  [前端自用展示] 图片数据 编辑用
          videoInfo: { //  [前端自用展示] 视频数据 编辑用
            duration: null,
            size: null,
            publishedMediaUrl: null
          },
          brandName: null, // 品牌名称（非视频广告必传）
          brandLogoAssetID: null, // 品牌logo asset id（非视频广告必传）
          brandLogoUrl: null, // 品牌logo url（非视频广告必传
          headline: null, // 标题（非视频广告必传）
          asins: [], // 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
          asinsItem: [], // [前端自用展示] 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
          videoMediaIds: [], // 视频媒体id（视频广告专有，最大一个）
        },
        addLaunchType: { // 4. 投放类型
          targetingType: 0, // 投放类型
          bidOptimization: true, // 竞价优化（设置成true后，亚马逊将自动优化竞价）
          keywords: [], // 关键词列表
          negativeKeywords: [], // 否定关键词列表
          targetsDTO: [], // 商品投放列表
          negativeTargets: [], // 否定商品投放列表
        },
      },
      brandListObj: {}, // 品牌保存form数据
    }
  },
  watch: {
    "formsError.list": {
      handler(newVal, oldVal) {
        // 处理左侧icon状态
        let leftSign = newVal.reduce((obj, item) => {
          switch (item.anchorIndex) {
            case "#id1":
              obj.complete0 = false
              break;
            case "#id2":
              obj.complete1 = false
              break;
            case "#id3":
              obj.complete2 = false
              break;
            case "#id4":
              obj.complete3 = false
              break;
          }
          return obj
        },  { complete0: true, complete1: true, complete2: true, complete3: true })
        this.leftSign[0].complete = leftSign.complete0
        this.leftSign[1].complete = leftSign.complete1
        this.leftSign[2].complete = leftSign.complete2
        this.leftSign[3].complete = leftSign.complete3
      },
      deep: true
    }
  },
  provide () {
    return {
      getPublicObj: () => this.publicObj, // 抛出公共对象
      getForms: () => this.forms, // 抛出forms对象
      getOptions: () => this.options, // 抛出枚举
      getBrandListObj: () => this.brandListObj, // 切换品牌保存的全局form数据
      anchorRoll: this.anchorRoll, // 抛出的锚点滚动事件方法
      getLandingPage: this.getLandingPage, // 根据品牌获取着陆页方法
      formsChange: this.formsChange, // 更新forms方法
      getLogCacheByBrandEntityId: this.getLogCacheByBrandEntityId, // 获取缓存logo方法
    }
  },
  mounted() {
    window.onbeforeunload = e => {
      return ""
    }
  },
  deactivated() {
    setTimeout(() => {
      sessionStorage.setItem("redirect", "")
    }, 300);
    window.onbeforeunload = function(e) {};
    window.onunload = function(e) {};
  },
  computed: {
    ...mapGetters({
      markets: 'authMarkets'
    }),
    formsError() {
      let formsError = {
        status: 0, // 0: 有必填项未填写、1：不可以提交草稿和审核、2：前端form校验通过
        list: [],
      }
      // 通用错误
      if (!this.forms.addBase.name) {
        formsError.list.push({ msg: "基础信息-广告活动名称未填写", anchorIndex: "#id1" })
      }
      if (!this.forms.addBase.brandEntityId) {
        formsError.list.push({ msg: "基础信息-品牌未选择", anchorIndex: "#id1" })
      }
      if (![0, 1].includes(this.forms.addBase.budgetType)) {
        formsError.list.push({ msg: "基础信息-预算类型未选择", anchorIndex: "#id1" })
      }
      if (!this.forms.addBase.budget) {
        formsError.list.push({ msg: "基础信息-预算未填写", anchorIndex: "#id1" })
      }
      if (!this.forms.addBase.startDate) {
        formsError.list.push({ msg: "基础信息-开始时间未选择", anchorIndex: "#id1" })
      }
      if (this.forms.addBase.budgetType === 0 && !this.forms.addBase.endDate) {
        formsError.list.push({ msg: "基础信息-结束时间未选择", anchorIndex: "#id1" })
      }
      // 商品集
      if (this.forms.addAdvertisingFormat.adFormat === 0) {
        if (this.forms.addAdvertisingFormat.adFormatUrl === null) {
            formsError.list.push({ msg: "广告格式-着陆页未选择", anchorIndex: "#id2" })
        }
        if (this.forms.addAdvertisingFormat.adFormatUrl === 0 && !this.forms.addAdvertisingFormat.landingPage.url) {
            formsError.list.push({ msg: "广告格式-品牌旗舰店店铺页面未选择", anchorIndex: "#id2" })
        }
        if (this.forms.addAdvertisingFormat.adFormatUrl === 1 && (!this.forms.addAdvertisingFormat.landingPage.asinsItem || this.forms.addAdvertisingFormat.landingPage.asinsItem.length == 0)) {
          formsError.list.push({ msg: "广告格式-商品着陆页未选择", anchorIndex: "#id2" })
        }
        if (this.forms.addAdvertisingFormat.adFormatUrl === 1 && (this.forms.addAdvertisingFormat.landingPage.asinsItem && this.forms.addAdvertisingFormat.landingPage.asinsItem.length >= 120)) {
          formsError.list.push({ msg: "广告格式-添加商品不可超过120条", anchorIndex: "#id2" })
        }
        if (!this.forms.creative.brandName) {
          formsError.list.push({ msg: "创意-品牌名称未填写", anchorIndex: "#id3" })
        }
        if (!this.forms.creative.brandLogoAssetID) {
          formsError.list.push({ msg: "创意-品牌logo未上传", anchorIndex: "#id3" })
        }
        if (!this.forms.creative.asins || !this.forms.creative.asins.join("")) {
          formsError.list.push({ msg: "创意-商品列表未选择", anchorIndex: "#id3" })
        }
        if (!this.forms.creative.headline) {
          formsError.list.push({ msg: "创意-标题未填写", anchorIndex: "#id3" })
        }
      }
      // 视频
      if (this.forms.addAdvertisingFormat.adFormat === 1) {
        if (!this.forms.creative.asins || !this.forms.creative.asins.join("")) {
          formsError.list.push({ msg: "广告格式-商品详情页未选择", anchorIndex: "#id2" })
        }
      }
      // 关键词
      if (this.forms.addLaunchType.targetingType == 0) {
        if (!this.forms.addLaunchType.keywords || this.forms.addLaunchType.keywords.length == 0) {
          formsError.list.push({ msg: "投放类型-请添加关键词", anchorIndex: "#id4" })
        }
        if (this.forms.addLaunchType.keywords && this.forms.addLaunchType.keywords.some(e => !e.bid)) {
          formsError.list.push({ msg: "投放类型-请填写关键词竞价", anchorIndex: "#id4" })
        }
      }
      // 商品投放
      if (this.forms.addLaunchType.targetingType == 1) {
        if (!this.forms.addLaunchType.targetsDTO || this.forms.addLaunchType.targetsDTO.length == 0) {
          formsError.list.push({ msg: "投放类型-请添加商品投放", anchorIndex: "#id4" })
        }
        if (this.forms.addLaunchType.targetsDTO && this.forms.addLaunchType.targetsDTO.some(e => !e.bid)) {
          formsError.list.push({ msg: "投放类型-请填写商品投放竞价", anchorIndex: "#id4" })
        }
      }
      // 状态判断
      if (!this.forms.addBase.name || !this.forms.addBase.budget) formsError.status = 1
      if (formsError.list.length == 0) formsError.status = 2

      return formsError
    }
  },
  methods: {
  // 获取详情
    async campaignInfo(param = {}) {
      let params = {
        marketId: this.publicObj.SB.marketId,
        campaignId: this.$route.query.campaignId,
      }
      Object.assign(params, param)
      try {
        let { data } = await campaignInfo(params)
        this.formsMap(data)
      } catch (error) {
        console.log('zs', error);
      }
    },
    // 映射forms
    formsMap(data) {
      this.detailsData = data
      // 1. 基础信息
      this.forms.addBase.name = data.campaignName || null  // 广告活动名称
      this.forms.addBase.budget = data.budget || null  // 活动预算
      this.forms.addBase.budgetType = data.budgetType  // 0:lifetime：生命周期 1: daily：每日
      this.forms.addBase.startDate = data.startDate || new Date()  // 活动开始时间（YYYY-MM-DD）
      this.forms.addBase.endDate = data.endDate || null  // 活动结束时间（YYYY-MM-DD）
      this.forms.addBase.brandEntityId = data.brandEntityId || null  // 品牌id
      this.forms.addBase.portfolioId = data.portfolioId || null  // 广告组合id
      // 2. 广告格式
      this.forms.addAdvertisingFormat.adFormat =  data.adFormat || 0  // 0：productCollection ： 品牌广告商品集合广告 1：video ： 品牌广告视频广告	
      // 0: url 1: 商品
      if (data.landingPageVo.pageType != 'store') {
          this.forms.addAdvertisingFormat.adFormatUrl = 1
          this.forms.addAdvertisingFormat.landingPage.asins = data.landingPageVo.asins || [] 
          this.forms.addAdvertisingFormat.landingPage.asinsItem = data.landingPageVo.productVOS || [] 
      }else {
          this.forms.addAdvertisingFormat.adFormatUrl = 0
          this.forms.addAdvertisingFormat.landingPage.url = data.landingPageVo.url || null
      }
      // 3. 创意
      this.forms.creative.imgInfo = {} //  [前端自用展示] 图片数据 编辑用
      this.forms.creative.videoInfo.duration = null // [前端自用展示] 视频数据 编辑用
      this.forms.creative.videoInfo.size = null // [前端自用展示] 视频数据 编辑用
      this.forms.creative.videoInfo.publishedMediaUrl =  data.creativeVo.videoUrl // [前端自用展示] 视频数据 编辑用
      this.forms.creative.brandName = data.creativeVo.brandName || null // 品牌名称（非视频广告必传）
      this.forms.creative.brandLogoAssetID = data.creativeVo.brandLogoAssetID || null  // 品牌logo asset id（非视频广告必传）
      this.forms.creative.brandLogoUrl = data.creativeVo.brandLogoUrl || null  // 品牌logo url（非视频广告必传
      this.forms.creative.headline = data.creativeVo.headline || null   // 标题（非视频广告必传）
      this.forms.creative.asins = data.creativeVo.asins || [] // 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
      this.forms.creative.asinsItem = data.creativeVo.productVOS || []// [前端自用展示] 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
      this.forms.creative.videoMediaIds = data.creativeVo.videoMediaIds || [] // 视频媒体id（视频广告专有，最大一个）
      // 4. 投放类型
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.AddLaunchType) {
            this.$refs.AddLaunchType.form.targetingType = data.targetingType || 0 // 投放类型
            this.$refs.AddLaunchType.form.bidOptimization = data.bidOptimizationDesc
            this.$refs.AddLaunchType.form.keywordPickerForm1.items = data.keywords || []
            this.$refs.AddLaunchType.form.keywordPickerForm2.items = (data.negativeKeywords || []).map(e => ({
              ...e,
              keyword: e.keywordText,
              matchTypeText: e.matchType === 0 ? "否定精准" : "否定词组"
            }))
            this.$refs.AddLaunchType.form.productTargetPickerForm.items = (data.targetsBeansVo || []).map(e => ({
              ...e,
              type: e.asin ? 'asin' : 'categoryPath',
              identity: e.asin ? `asin_${e.asin}` : `categoryPath_${e.categoryPath}`,
            }))
            this.$refs.AddLaunchType.form.autoTargetPickerForm.items = (data.negativeTargetings || []).map(e => ({
              ...e,
              id: e.brandId
            }))
          }
        })
      }, 300);
      // this.forms.addLaunchType.targetingType = data.targetingType || 0 // 投放类型
      // this.forms.addLaunchType.bidOptimization = data.bidOptimization || false // 竞价优化（设置成true后，亚马逊将自动优化竞价）
      // this.forms.addLaunchType.keywords = data.keywords || [] // 关键词列表
      // this.forms.addLaunchType.negativeKeywords = data.negativeKeywords || [] // 否定关键词列表
      // this.forms.addLaunchType.targets = data.targets || [] // 商品投放列表
      // this.forms.addLaunchType.negativeTargets = data.negativeTargets || [] // 否定商品投放列表
    },
    // 根据站点id获取基本信息
    async getMarket(marketId) {
      let market = await getMarket(marketId);
      this.publicObj.SB.market = market;
      this.publicObj.SB.currencySymbol = market.currencySymbol;
    },
    // 查询广告组合
    async getPortfolio(marketId) {
      let { data } = await Portfolios.getPortfolios({marketId: marketId || this.marketId});
      this.publicObj.SB.portfolios = data;
    },
    formsChange(forms) {
      this.forms.leftIndex = forms.leftIndex  // [前端自用展示]
      this.forms.draft= forms.draft  // 草稿标志（0：草稿；1：非草稿）
      this.forms.marketId= forms.marketId  // 站点id
      // 1. 基础信息
      this.forms.addBase.budget= forms.addBase.budget  // 活动预算
      this.forms.addBase.budgetType= forms.addBase.budgetType  // 0:lifetime：生命周期 1 daily：每日
      this.forms.addBase.startDate= forms.addBase.startDate // 活动开始时间（YYYY-MM-DD）
      this.forms.addBase.endDate= forms.addBase.endDate  // 活动结束时间（YYYY-MM-DD）
      this.forms.addBase.portfolioId= forms.addBase.portfolioId  // 广告组合id
      // 2. 广告格式
      this.forms.addAdvertisingFormat.adFormat= forms.addAdvertisingFormat.adFormat  // 0：productCollection ： 品牌广告商品集合广告 1：video ： 品牌广告视频广告	
      this.forms.addAdvertisingFormat.adFormatUrl= forms.addAdvertisingFormat.adFormatUrl  // 0= url 1= 商品
      this.forms.addAdvertisingFormat.landingPage.asins= forms.addAdvertisingFormat.landingPage.asins 
      this.forms.addAdvertisingFormat.landingPage.asinsItem= forms.addAdvertisingFormat.landingPage.asinsItem 
      this.forms.addAdvertisingFormat.landingPage.url= forms.addAdvertisingFormat.landingPage.url
      // 3. 创意 //  [前端自用展示] 视频数据 编辑用
      this.forms.creative.videoInfoduration= forms.creative.videoInfoduration 
      this.forms.creative.videoInfosize= forms.creative.videoInfosize 
      this.forms.creative.videoInfopublishedMediaUrl= forms.creative.videoInfopublishedMediaUrl
      this.forms.creative.brandName= forms.creative.brandName  // 品牌名称（非视频广告必传）
      this.forms.creative.brandLogoAssetID= forms.creative.brandLogoAssetID  // 品牌logo asset id（非视频广告必传）
      this.forms.creative.brandLogoUrl= forms.creative.brandLogoUrl  // 品牌logo url（非视频广告必传
      this.forms.creative.headline= forms.creative.headline  // 标题（非视频广告必传）
      this.forms.creative.asins= forms.creative.asins  // 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
      this.forms.creative.asinsItem= forms.creative.asinsItem  // [前端自用展示] 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
      this.forms.creative.videoMediaIds= forms.creative.videoMediaIds  // 视频媒体id（视频广告专有，最大一个）
      // 4. 投放类型
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.AddLaunchType.form.targetingType = forms.addLaunchType.targetingType// 投放类型
          this.$refs.AddLaunchType.form.bidOptimization = forms.addLaunchType.bidOptimization
          this.$refs.AddLaunchType.form.keywordPickerForm1.items = forms.addLaunchType.keywords || []
          this.$refs.AddLaunchType.form.keywordPickerForm2.items = forms.addLaunchType.negativeKeywords || []
          this.$refs.AddLaunchType.form.productTargetPickerForm.items = forms.addLaunchType.targetsDTO || []
          this.$refs.AddLaunchType.form.autoTargetPickerForm.items = forms.addLaunchType.negativeTargets || []
        })
      }, 300);
    },
    // 获取缓存logo
    async getLogCacheByBrandEntityId(param) {
      let params = {
        marketId: this.publicObj.SB.marketId,
        brandEntityId: null
      }
      Object.assign(params, param)
      try {
        let { data } = await getLogCacheByBrandEntityId(params)
        data && (this.forms.creative.brandLogoUrl = data.brandLogoUrl)
        data && (this.forms.creative.brandLogoAssetID = data.brandLogoAssetID)
      } catch (error) {
        console.log('zs', error);
      }
    },
    // 获取产品品牌信息
    async listProductBrand(marketId) {
      this.options.loading.brandEntity = true
      try {
        let params =  { marketId }
        let { data } = await listProductBrand(params)
        this.options.brandEntity = data.reduce((arr, item) => {
          arr = arr.concat({id: item.brandEntityId, text: item.brandRegistryName})
          var forms = this._.cloneDeep(this.forms);
          this.brandListObj[item.brandEntityId] = forms
          return arr
        }, [])
      } catch (error) {
        console.log("error", error);
      } finally {
        this.options.loading.brandEntity = false
      }
    },
    // 根据品牌获取着陆页
    async getLandingPage(brandEntityId) {
      let params = {
        marketId: this.publicObj.SB.marketId,
        brandEntityId: brandEntityId || this.forms.addBase.brandEntityId
      }
      this.options.loading.shopOptions = true
      try {
        let { data = [] } = await getLandingPage(params)
        this.options.shopOptions = data.map(item => {
          return {
            id: item.storePageUrl,
            text: item.storePageName,
          }
        });
      } finally {
        this.options.loading.shopOptions = false
      }
    },
    // form数据提交前处理
    formsPretreatment(draft) {
      let formParams = {
        draft: draft, // 草稿标志（0：草稿；1：非草稿）
        marketId: this.publicObj.SB.marketId, // 站点id
        name: this.forms.addBase.name, // 广告活动名称
        budget: this.forms.addBase.budget, // 活动预算
        budgetType: this.forms.addBase.budgetType, // 0:lifetime：生命周期,1: daily：每日
        startDate: convertToDate(this.forms.addBase.startDate), // 活动开始时间（YYYY-MM-DD）
        endDate: convertToDate(this.forms.addBase.endDate), // 活动结束时间（YYYY-MM-DD）
        brandEntityId: this.forms.addBase.brandEntityId, // 品牌id
        portfolioId: this.forms.addBase.portfolioId, // 广告组合id
        adFormat: this.forms.addAdvertisingFormat.adFormat, // 0：productCollection ： 品牌广告商品集合广告,1：video ： 品牌广告视频广告	
        adFormatUrl: this.forms.addAdvertisingFormat.adFormatUrl, // 0: url 1: 商品
        landingPage: {
          asins: this.forms.addAdvertisingFormat.landingPage.asinsItem.map(e => e.asin),
          url: this.forms.addAdvertisingFormat.landingPage.url
        },
        creative: {
          brandName: this.forms.creative.brandName, // 品牌名称（非视频广告必传）
          brandLogoAssetID: this.forms.creative.brandLogoAssetID, // 品牌logo asset id（非视频广告必传）
          brandLogoUrl: null, // 品牌logo url（非视频广告必传
          headline: this.forms.creative.headline, // 标题（非视频广告必传）
          asins: this.forms.creative.asins.filter(e => e), // 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
          videoMediaIds: this.forms.creative.videoMediaIds, // 视频媒体id（视频广告专有，最大一个）
        },
        targetingType: this.forms.addLaunchType.targetingType, // 投放类型
        bidOptimization: this.forms.addLaunchType.bidOptimization, // 竞价优化（设置成true后，亚马逊将自动优化竞价）
        keywords: this.forms.addLaunchType.keywords, // 关键词列表
        negativeKeywords: this.forms.addLaunchType.negativeKeywords, // 否定关键词列表
        targetsDTO: this.forms.addLaunchType.targetsDTO, // 商品投放列表
        negativeTargets: this.forms.addLaunchType.negativeTargets.map(e =>({
          expressions: [{
            type: e.type,
            value: e.value
          }]
        })), // 否定商品投放列表
      }
      // 清除多余数据  ------------------- ---------------------------------------------------
      // 清除广告格式
      if (formParams.adFormatUrl == 0) {
        formParams.landingPage.asins = []
      }else {
        formParams.landingPage.url = null
      }
      // 清除商品集，视频
      if (formParams.adFormat == 0) {
        formParams.creative.videoMediaIds = null
      }else {
        formParams.creative.brandName = null
        formParams.creative.brandLogoAssetID = null
        formParams.creative.brandLogoUrl = null
        formParams.creative.headline = null
      }
      /**
       * 投放类型清除
       * formParams.targetingType == 0 ? 类型关键词 : 类型商品投放
      */
      if (formParams.targetingType == 0) {
        formParams.targetsDTO = null
        formParams.negativeTargets = null
      }else {
        formParams.keywords = null
        formParams.negativeKeywords = null
      }
      return formParams
    },
    saveDraft() {
      this.$gjCreate(AddPopup, {
        props: {
          title: "确认提交草稿",
          warning: "一旦确认提交，着陆页信息将不可修改！",
          details: ["确定要提交吗？"]
        },
        on: {
          confirm: async () => {
            let params = this.formsPretreatment(0)
            try {
              this.pageLoading = true
              let res = await saveAdsSbCampaigns(params)
              this.pageLoading = false
              if (res.code == 0) {
                this.$message.success(res.msg || "新增成功")
                this.$router.push('/ad/sb-ad/ad-manager')
                // 删除新增品牌广告页签
                sessionStorage.setItem('ignore', 0);
                this.removeTab('新增广告活动')
              }
            } catch (error) {
              this.pageLoading = false
              console.log('zs', error)
            }
          }
        }
      })
    },
    // 提交
    confirm() {
      this.$gjCreate(AddPopup, {
        props: {
          title: "确认提交审核",
          warning: "一旦确认提交，广告内容将不可修改！",
          details: ["确定要提交吗？"]
        },
        on: {
          confirm: async () => {
            let params = this.formsPretreatment(1)
            if (this.formsError.status != 2) {
              setTimeout(() => {
                if (this.formsError.status != 2) this.noConfirm()
              }, 200);
              return false
            }
            try {
              this.pageLoading = true
              let res = await saveAdsSbCampaigns(params)
              this.pageLoading = false
              if (res.code == 0) {
                this.$message.success(res.msg || "新增成功")
                this.$router.push('/ad/sb-ad/ad-manager')
                // 删除新增品牌广告页签
                sessionStorage.setItem('ignore', 0);
                this.removeTab('新增广告活动')
              }
            } catch (error) {
              this.pageLoading = false
              console.log('zs', error)
            }
          }
        }
      })
    },
    // 无法提交
    noConfirm() {
      this.$gjCreate(AddPopup, {
        props: {
          title: "无法提交",
          warning: "广告内容未填写完整，无法提交：",
          details: this.formsError.list
        },
        on: {
          edit: (index) => {
            this.anchorRoll(index)
          },
          confirm: () => {
            this.anchorRoll(this.formsError.list[0].anchorIndex)
          }
        }
      })
    },
    // 锚点滚动事件
    anchorRoll(id) {
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
    },
    rightContentScroll(e) {
      this.rightScrollTop = e.srcElement.scrollTop
      // 到顶判断
      if (e.srcElement.scrollTop == 0) {
        return this.forms.leftIndex = "1"
      }
      // 到底判断
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight ==  e.srcElement.scrollHeight) {
        return this.forms.leftIndex = "4"
      }
      // 高度位置判断
      let childNodesHeight = [...e.srcElement.childNodes].map( item =>  item.offsetHeight )
      for (let index = 0; index < this.leftSign.length; index++) {
        if (e.srcElement.scrollTop < this.addNum(childNodesHeight, index + 1)) {
          return this.forms.leftIndex = this.leftSign[index].index
        }
      }
    },
    addNum(arr = [], num) {
      return arr.slice(0, num).reduce((total, item) => {
        return total + item
      }, 0) - 200
    },
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/views/modules/ad/common/common.scss';
  /deep/.vxe-header--column {
    background: #fff;
    span {
      font-weight: 500 !important;
    }
  }
  /deep/.el-tabs__nav-wrap {
    padding: 0 12px;
  }
  /deep/ .right-container-bg{
    padding-left: 0;
    padding-right: 0;
  }
  @media screen and (max-width: 1400px) {
      /deep/ .base-content{
        padding: 0 16px !important;
      }
      /deep/.left-container {
        max-width: 120px !important;
        min-width: 120px !important;
        .left-content {
          padding: 25px 0 0 10px;
        }
        .right-market {
          padding: 10px;
        }
      }
      /deep/.right-container {
        // width: calc(100vw - 168px) !important;
        // width: calc(100vw - 168px) !important;
        .AddLaunchType {
          .gj-picker {
            width: 1090px !important;
          }
        }
      }
      /deep/.add-cell {
        margin-left: 10px !important;
      }
  }
  .ml18 {
    margin-left: 18px;
  }
  /deep/.container {
    height: 100%;
  }
  .right-market {
    border-bottom: 1px solid #EBEEF5;
    font-size: 12px;
    padding: 10px 0;
    padding-left: 32px;
    color: #666;
  }
  .left-content {
    padding: 25px 0 0 32px;
    font-size: 14px;
    -webkit-user-select: none;
    .left-cell {
      display: flex;
      align-items: center;
      padding-bottom: 47px;
      position: relative;
      cursor: pointer;
      .cell-index {
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 100%;
        border: 1px solid #999;
        &.cell-complete {
          font-size: 13px;
          font-weight: 900;
          color: #1F6EEF ;
          border: 1px solid #1F6EEF;
        }
      }
      .cell-title {
        padding-left: 10px;
      }
      &.active {
        color: #1F6EEF ;
        .cell-index {
          color: #fff ;
          border: 1px solid #1F6EEF;
          background: #1F6EEF;
        }
      }
      &::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 35px;
        bottom: 6px;
        left: 9px;
        background: #E4E5E6;
      }
      &.guide-line {
        .cell-index {
          color: #1F6EEF ;
          border: 1px solid #1F6EEF;
        }
        &::after {
          background: #1F6EEF;
        }
      }
      &:last-child {
        &::after {
          height: 0;
        }
      }
    }
  }
  .right-content {
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    .right-scroll {
      flex: 1;
      overflow: auto;
    }
    .right-footer {
      height: 45px;
      box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.1);
      // border-radius: 220px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
